export default __webpack_public_path__ + "static/media/note-2_blue.221e1ab4.svg";